// src/api/axiosInstance.js

import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
	(config) => {
		const currentTime = Date.now();

		try {
			const url = new URL(config.url, window.location.origin);

			if (!url.searchParams.has('time')) {
				url.searchParams.append('time', currentTime);
			}

			config.url = url.toString();
		} catch (err) {
			console.warn('Could not append time to URL:', config.url, err);
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default axiosInstance;
